'use client';

import { useCallback, useEffect, useState } from 'react';
import { cn } from '../../../../libs/utils/TailwindMerge';
import { AnimatedNotificationWrapper } from './AnimatedNotificationWrapper';
import { INotification } from './INotification';

import { useDispatch } from 'react-redux';
import { setNotifications } from '../../../../redux/features/app/appSlice';
import NotificationItem from './NotificationItem';

interface INotificationsProps {
    messages: INotification[];
    className?: string;
}

export function Notifications({ messages, className }: INotificationsProps) {
    const [isHidden, setIsHidden] = useState(false);
    const dispatch = useDispatch();

    useEffect(() => {
        if (messages.length > 0) {
            setIsHidden(false);
        }
    }, [messages]);

    const onHide = useCallback(() => {
        setIsHidden(true);
        dispatch(setNotifications([]));
    }, [dispatch]);

    return (
        !isHidden && (
            <div className={cn('fixed top-8 md:top-0 overflow-hidden rounded-lg p-6 left-1/2 -translate-x-1/2 w-fit mx-auto z-[60]', className)}>
                <AnimatedNotificationWrapper>
                    {messages.map((notification, idx) => (
                        <NotificationItem key={idx} notification={notification} onHide={onHide} />
                    ))}
                </AnimatedNotificationWrapper>
            </div>
        )
    );
}
